import { common } from "../../constants/apiUrl";
import { IApiResponse } from "../../models/IAPIResponse";
import APIService from "../../helper/api-service";
import { ICampusSafetyAlerts } from "../../models/common/INavbar";

export default new (class CampusSafetyAlertService {
    public getSafetyAlerts = async (): Promise<IApiResponse<ICampusSafetyAlerts>> => {
        try {
            let endPoint = common.GET_SAFETY_ALERT_CAMPUS;
            const response = await APIService.get(endPoint);
            return response.data as IApiResponse<ICampusSafetyAlerts>;
        } catch (error: any) {
            if (error.response) {
                return error.response as IApiResponse<ICampusSafetyAlerts>;
            } else {
                throw error;
            }
        }
    };
})();